module.exports = __webpack_public_path__ + "assets/media/september-2@2x.bb7e05ee.png";